var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 123,
    viewBox: "0 0 124 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5 payment 1",
    clipPath: "url(#clip0_3333_1221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M118.514 22.7492L43.3087 6.83358C40.1268 6.16041 36.9731 8.21322 36.2999 11.3951L34.8711 20.577L121.646 38.9399L123.075 29.758C123.748 26.5773 121.696 23.4226 118.514 22.7492Z",
    fill: "#5E9C81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M86.8884 40.8872C86.01 37.7238 82.7041 35.854 79.5418 36.731L65.265 40.6944L31.6083 33.5714L27.9068 51.0607L4.77952 57.4798C1.61734 58.357 -0.252477 61.6629 0.624546 64.8252L13.6581 111.792C14.5365 114.954 17.8426 116.825 21.0047 115.947L95.767 95.1996C98.9292 94.3212 100.799 91.0165 99.922 87.853L97.6848 79.7902L106.07 81.5629C109.251 82.2373 112.405 80.1845 113.078 77.0026L118.383 51.9345L88.1808 45.5434L86.8884 40.8872ZM95.5224 64.7576L97.3714 56.0191C97.649 54.7107 98.9464 53.8668 100.255 54.1431L108.993 55.9932C110.303 56.2709 111.147 57.5669 110.87 58.8765L109.021 67.615C108.744 68.9234 107.447 69.7686 106.138 69.4911L97.3996 67.6421C96.0888 67.3634 95.2447 66.066 95.5224 64.7576ZM6.08051 62.1667L26.7701 56.427L75.587 42.88L80.8401 41.4205C80.9361 41.3946 81.0318 41.3824 81.1253 41.3824C81.5466 41.3824 82.0504 41.6589 82.1977 42.1884L82.8145 44.4095L84.7469 51.3727L7.86184 72.7086L5.31264 63.5255C5.15292 62.9492 5.50445 62.3264 6.08051 62.1667ZM95.2337 89.1525C95.332 89.5089 95.2289 89.8036 95.1243 89.988C95.0212 90.1722 94.8221 90.4132 94.4658 90.5113L19.705 111.259C19.6105 111.285 19.5133 111.298 19.4198 111.298C18.9985 111.298 18.4947 111.02 18.3474 110.491L10.7453 83.0958L87.6304 61.7588L92.3197 78.6548L95.2337 89.1525Z",
    fill: "#5E9C81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.7852 91.0272C31.4264 89.7372 30.0799 88.9756 28.79 89.3331L20.0589 91.7569C18.7701 92.1145 18.0073 93.4622 18.366 94.7522L20.7886 103.482C21.1474 104.772 22.4939 105.534 23.7838 105.175L32.5149 102.752C33.8049 102.395 34.5666 101.047 34.209 99.7571L31.7852 91.0272Z",
    fill: "#5E9C81"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3333_1221"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.794,
    height: 122.794,
    fill: "white",
    transform: "translate(0.408203 0.0374985)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.9119658c36cabf973671c8e0970f1ec2.svg";
export { ForwardRef as ReactComponent };